module.exports = __webpack_public_path__ + "img/solution_2.1769232b.png";